import React, { useEffect, useState, useRef } from "react";
import ecg from "../../../Assets/Images/ecgNewGray.png";
import { BiSolidVideoPlus } from "react-icons/bi";
import { LuFileCheck2 } from "react-icons/lu";
import { Modal, DatePicker, message, Button } from "antd";
import dayjs from "dayjs";
import ConsultationService from "../../../Services/ConsultationService";
import { ExpandOutlined } from "@ant-design/icons";

function DigitalECG(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("live");
  const [ecgList, setEcgList] = useState([]);
  const [ecgUrl, setEcgUrl] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [loading, setLoading] = useState(false);

  const formatDateForApi = (d) => (d ? dayjs(d).format("MM/DD/YYYY") : null);

  useEffect(() => {
    if (
      props.patientDetails &&
      props.patientDetails.patientId &&
      activeTab === "saved"
    ) {
      setLoading(true);

      let fromDate = selectedDate ? formatDateForApi(selectedDate) : undefined;
      let toDate = selectedDate ? formatDateForApi(selectedDate) : undefined;

      ConsultationService.fetchECGgraph({
        patientId: props.patientDetails.patientId,
        ...(fromDate && { fromDate }),
        ...(toDate && { toDate }),
      })
        .then((res) => {
          setLoading(false);
          if (Array.isArray(res.data) && res.data.length > 0) {
            setEcgList(res.data);
            setEcgUrl(res.data[0].resultDocumentName);
          } else {
            setEcgList([]);
            setEcgUrl("");
          }
        })
        .catch(() => {
          setLoading(false);
          setEcgList([]);
          setEcgUrl("");
          message.error("Failed to fetch ECG graphs.");
        });
    }
  }, [props.patientDetails, selectedDate, activeTab]);

  const showModal = () => setIsModalOpen(true);
  const handleOk = () => setIsModalOpen(false);
  const handleCancel = () => setIsModalOpen(false);

  const handleTabSwitch = (tab) => {
    setActiveTab(tab);
    if (tab === "live") {
      setEcgUrl("");
    }
  };

  const onDateChange = (date) => setSelectedDate(date);

  const handleEcgSelection = (url) => {
    setEcgUrl(url);
  };

  const handleOpenGraphModal = (url) => {
    setEcgUrl(url);
    setIsModalOpen(true);
  };

  return (
    <div className="h-full overflow-x-scroll bg-white p-1">
      <div className="flex gap-2 my-2 cursor-pointer items-center">
        <span
          onClick={() => {
            handleTabSwitch("live");
            showModal();
          }}
          className={`flex gap-2 rounded-full px-2 justify-center items-center ${
            activeTab === "live" ? "bg-[#FFD9D9]" : ""
          }`}
        >
          <BiSolidVideoPlus className="text-[#FF4949] w-6 h-6" />
          <span>Live Streaming</span>
        </span>
        <span
          onClick={() => handleTabSwitch("saved")}
          className={`flex gap-2 rounded-full px-2 justify-center items-center ${
            activeTab === "saved" ? "bg-[#F5FFFF]" : ""
          }`}
        >
          <LuFileCheck2 />
          <span>Saved Graphs</span>
        </span>
        <span className="text-sm text-gray-500 flex gap-2 items-center">
          <DatePicker
            style={{ width: 130 }}
            format="MM/DD/YYYY"
            value={selectedDate}
            onChange={onDateChange}
            allowClear
            placeholder="Select Date"
            size="small"
          />
        </span>
      </div>
      {activeTab === "live" ? (
        <img src={ecg} alt="ecg" className="w-full h-[200px]" />
      ) : loading ? (
        <div
          style={{
            width: 400,
            height: 150,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "1px solid #e5e7eb",
            borderRadius: 8,
            background: "#f3f4f6",
          }}
        >
          <span style={{ color: "#6b7280" }}>Loading ECG Graphs...</span>
        </div>
      ) : ecgList.length > 0 ? (
        <div style={{ width: "100%" }}>
          {ecgList.map((item) => (
            <div key={item.id} style={{ width: "100%" }}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  type="primary"
                  size="small"
                  icon={<ExpandOutlined />}
                  onClick={() => handleOpenGraphModal(item.resultDocumentName)}
                />
              </div>
              <div style={{ width: "100%", overflow: "hidden" }}>
                <iframe
                  src={item.resultDocumentName}
                  title={`ECG Graph ${item.id}`}
                  style={{
                    width: "155%",
                    height: "190px",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    transform: "scaleX(0.65)",
                    transformOrigin: "left center",
                    display: "block",
                  }}
                  frameBorder="0"
                  allowFullScreen
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div
          style={{
            width: 400,
            height: 150,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            border: "1px solid #e5e7eb",
            borderRadius: 8,
            background: "#f3f4f6",
          }}
        >
          <span style={{ color: "#6b7280" }}>No ECG Graph Available</span>
        </div>
      )}
      <Modal
        title="ECG"
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
        width={1200}
      >
        <div style={{ width: "100%" }}>
          <iframe
            src={ecgUrl}
            title="ECG Modal Graph"
            style={{
              width: "100%",
              height: "500px",
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              display: "block",
            }}
            frameBorder="0"
            allowFullScreen
          />
        </div>
      </Modal>
    </div>
  );
}

export default DigitalECG;
